import React from "react";
import { Select } from "antd";

const { Option } = Select;

const SingleSelector = ({ options, onchange, attachSearch }) => {
  return (
    <Select
      size="small"
      allowClear={true}
      readOnly={true}
      className="attach-select"
      dropdownClassName="attach-dropdown multi-select-custom"
      getPopupContainer={() =>
        document.getElementsByClassName(
          "ant-layout-content layout-content site-layout-background custom-textarea"
        )[0]
      }
      showSearch
      placeholder=""
      optionFilterProp="children"
      onChange={(e) => onchange(e)}
      optionLabelProp="label"
      defaultValue={attachSearch}
      value={attachSearch}
      filterOption={(input, option) => {
        let str = option?.children?.slice(0, option?.children?.length - 2);
        return str.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
    >
      {options?.map(({ label, value }) => {
        return (
          <Option value={value} label={label}>
            {label || ""}
          </Option>
        );
      })}
    </Select>
  );
};

export default SingleSelector;
